export default "__VITE_ASSET__ALY5euXe__"